var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneLarge = function SvgPhoneLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#343839",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.03,
    strokeWidth: 9,
    d: "M62.244 66.556a4.5 4.5 0 0 0 5.459-1.364L69.3 63.1a9 9 0 0 1 7.2-3.6H90a9 9 0 0 1 9 9V82a9 9 0 0 1-9 9A81 81 0 0 1 9 10a9 9 0 0 1 9-9h13.5a9 9 0 0 1 9 9v13.5a9 9 0 0 1-3.6 7.2l-2.106 1.58a4.5 4.5 0 0 0-1.314 5.548 63 63 0 0 0 28.764 28.728"
  })));
};
export default SvgPhoneLarge;